import { ExternalLink } from "lucide-react";
import "./ProjectsSection.css";

// Projects Section
export default function ProjectsSection({ projects }) {
  return (
    <section
      id="projects"
      className="py-24 lg:py-32 bg-[#010A13]"
      data-testid="projects-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* <p className="section-title text-center">Portfolio</p> */}
        <h2 className="font-['Marcellus'] text-3xl sm:text-4xl text-[#F0E6D2] text-center mb-16 tracking-tight">
          Projects
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project, index) => (
            <div
              key={index}
              className="project-card"
              data-testid={`project-card-${index}`}
            >
              <div className="aspect-video overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
                />
              </div>
              <div className="p-6 flex flex-col flex-grow">
                <h3 className="font-['Marcellus'] text-xl text-[#F0E6D2] uppercase tracking-wider mb-3">
                  {project.title}
                </h3>
                <p className="text-[#A09B8C] text-sm leading-relaxed mb-4">
                  {project.description}
                </p>
                <div className="flex flex-wrap gap-2 mb-6">
                  {project.tags.map((tag, tagIndex) => (
                    <span
                      key={tagIndex}
                      className="px-3 py-1 bg-[#1E283D] text-[#0AC8B9] text-xs uppercase tracking-wider"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                <a
                  href={project.link}
                  className="btn-metal text-sm inline-flex items-center gap-2 mt-auto self-start"
                  data-testid={`project-link-${index}`}
                >
                  <span>View Project</span>
                  <ExternalLink size={14} />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
